import { render, staticRenderFns } from "./RecetaMainModal.vue?vue&type=template&id=66e34d59&"
import script from "./RecetaMainModal.vue?vue&type=script&lang=js&"
export * from "./RecetaMainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports